import { render } from "./Claim1_Eval.vue?vue&type=template&id=27483131&scoped=true"
import script from "./Claim1_Eval.vue?vue&type=script&lang=js"
export * from "./Claim1_Eval.vue?vue&type=script&lang=js"

import "./Claim1_Eval.vue?vue&type=style&index=0&id=27483131&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-27483131"

export default script